(function (module) {

    module.service('brandGroupNameService', ['$http', brandGroupNameService])

    function brandGroupNameService(this: $TSFixMe, $http: ng.IHttpService) {
        var service = this;

        service.get = () => {
            return $http.get('/api/configuration/brand-group-name')
                .then(function (response: $TSFixMe) { return response.data; });
        };

        service.edit = (entity: $TSFixMe) => {
            return $http.post('api/configuration/brand-group-name', entity);
        };

        service.add = (entity: $TSFixMe) => {
            return $http.put('api/configuration/brand-group-name', entity);
        };

        service.remove = (entity: $TSFixMe) => {
            return $http.delete('api/configuration/brand-group-name/' + entity.id);
        }

    }

})(angular.module('topline.modules'));